import ReturnReason from '../ReturnReason/ReturnReason'
import SortableList from '../SortableList/SortableList'
import SortableWrapper from '../SortableWrapper/SortableWrapper'

const SortableReturnReasonList = ({
  reasons,
  dragging,
  onChangeEnabled,
  onDelete,
  onEdit,
  isEditable,
  returnReasonsFiltering,
  onSortEnd,
  onSortStart,
}) => {
  return (
    <SortableList items={reasons} onSortEnd={onSortEnd} onSortStart={onSortStart}>
      <div>
        {reasons?.map((reason, index) => (
          <SortableWrapper key={reason.id} id={reason.id} dragging={dragging}>
            <ReturnReason
              reason={reason}
              index={index}
              onChangeEnabled={onChangeEnabled}
              onDelete={onDelete}
              onEdit={onEdit}
              isEditable={isEditable}
              returnReasonsFiltering={returnReasonsFiltering}
            />
          </SortableWrapper>
        ))}
      </div>
    </SortableList>
  )
}

export default SortableReturnReasonList
